export default "__VITE_ASSET__dAI9lsOq__"